import {
  NotificationSection,
  RedirectToDashboard,
} from '@/components/Navbar/components';
import { WhatsappContactSection } from '@/components/Navbar/components/WhatsappContactSection';
import { rightBarIconsStyles } from '@/components/RightBarIcons/RightBarIcons.style';
import { useBreakpoint, useShowNotifications } from '@/hooks';
import { Box } from '@mui/material';

export const RightBarIcons = () => {
  const { showBell } = useShowNotifications();
  const { classes } = rightBarIconsStyles();
  const { isDesktop } = useBreakpoint();

  return (
    <div className={classes.root}>
      {isDesktop && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
          }}
        >
          <WhatsappContactSection />
          <RedirectToDashboard />
        </Box>
      )}
      {showBell && <NotificationSection />}
    </div>
  );
};
